import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenApp } from '../models/open-app/open-app.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { OpenAppConfig } from '../models/open-app/open-app-config.model';

@Injectable({
  providedIn: 'root',
})
export class OmOpenAppConfigService extends RequestService<OpenAppConfig> {
  static PATH = '/om/open/app/config';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmOpenAppConfigService.PATH, globalService.debugUrl);
  }
}
